// extracted by mini-css-extract-plugin
module.exports = {"ratingDetails":"ie","ratingLabel":"if","ratingReason":"ih"};